import styled from 'styled-components';

export const AutoSuggest = styled.section`
  background: white;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
  border-radius: 1.2rem;
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 53rem;
  z-index: 7;
  ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 350px;
    overflow-y: scroll;
    li {
      padding: 2rem;
      border-top: 1px solid #eff3f8;
      display: flex;
      flex-direction: row;
      cursor: pointer;
      span {
        font-size: 1.6rem;
      }
      &:active {
        background: #eef4fd;
      }
      &:hover {
        background: #eef4fd;
      }
      &:first-child {
        border: 0;
      }
    }
  }
`;
